import { apiClient } from '../../client'
import { PaginatedResponse } from '../role.repository'

export interface PromoType {
  id: number
  tenant_id: number
  en_name: string
  ar_name: string
  status: number
  created_by: number
  created_at: string
  updated_by: number
  updated_at: string
}

export interface CreatePromoTypeRequest {
  en_name: string
  ar_name: string
  status?: number
}

export interface UpdatePromoTypeRequest {
  en_name?: string
  ar_name?: string
  status?: number
}

class PromoTypesRepository {
  async getAll(
    page: number = 1,
    limit: number = 10,
    filters?: { search?: string; status?: string },
  ): Promise<PaginatedResponse<PromoType>> {
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    })

    if (filters?.search?.trim()) params.append('search', filters.search.trim())
    if (filters?.status?.trim()) params.append('status', filters.status.trim())

    return apiClient.get<PaginatedResponse<PromoType>>(`/client-promo-types?${params.toString()}`)
  }

  async getOne(id: number): Promise<PromoType> {
    return apiClient.get<PromoType>(`/client-promo-types/${id}`)
  }

  async create(data: CreatePromoTypeRequest): Promise<PromoType> {
    return apiClient.post<PromoType>('/client-promo-types', data)
  }

  async update(id: number, data: UpdatePromoTypeRequest): Promise<PromoType> {
    return apiClient.put<PromoType>(`/client-promo-types/${id}`, data)
  }

  async remove(id: number): Promise<{ message: string }> {
    return apiClient.delete<{ message: string }>(`/client-promo-types/${id}`)
  }
}

export const promoTypesRepository = new PromoTypesRepository()

